import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import * as PrimeDataTable from "primereact/datatable";
import {
  Alert,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Spinner,
  UncontrolledDropdown,
} from "reactstrap";
import { Link } from "react-router-dom";

//import Images
import avatar2 from "../../../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../../../assets/images/users/avatar-3.jpg";
import avatar4 from "../../../../assets/images/users/avatar-4.jpg";
import avatar5 from "../../../../assets/images/users/avatar-5.jpg";
import avatar6 from "../../../../assets/images/users/avatar-6.jpg";
import avatar7 from "../../../../assets/images/users/avatar-7.jpg";
import avatar8 from "../../../../assets/images/users/avatar-8.jpg";
import avatar9 from "../../../../assets/images/users/avatar-9.jpg";
import avatar10 from "../../../../assets/images/users/avatar-10.jpg";

import btc from "../../../../assets/images/crypto-icons/btc.svg";
import eth from "../../../../assets/images/crypto-icons/eth.svg";
import ltc from "../../../../assets/images/crypto-icons/ltc.svg";
import xmr from "../../../../assets/images/crypto-icons/xmr.svg";
import ant from "../../../../assets/images/crypto-icons/ant.svg";
import sol from "../../../../assets/images/crypto-icons/sol.svg";
import fil from "../../../../assets/images/crypto-icons/fil.svg";
import aave from "../../../../assets/images/crypto-icons/aave.svg";
import ada from "../../../../assets/images/crypto-icons/ada.svg";
import { Column } from "primereact/column";

import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import axios from "axios";
import { useCookies } from "react-cookie";
import config from "../../../../config";
import { Dropdown } from "primereact/dropdown";
import { Ripple } from "primereact/ripple";
import { classNames } from "primereact/utils";
import { useSelector } from "react-redux"

const BasicTable = () => {
  const columns = [
    {
      name: (
        <Input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
      cell: () => (
        <input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">SR No.</span>,
      selector: (row) => row.srNo,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">ID</span>,
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Purchase ID</span>,
      selector: (row) => row.purchaseId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Title</span>,
      selector: (row) => <Link to="#!">{row.title}</Link>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">User</span>,
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Assigned To</span>,
      selector: (row) => row.assigned,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create By</span>,
      selector: (row) => row.createdBy,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create Date</span>,
      selector: (row) => row.createDate,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.status) {
          case "Re-open":
            return (
              <span className="badge badge-soft-info"> {cell.status} </span>
            );
          case "On-Hold":
            return (
              <span className="badge badge-soft-secondary">
                {" "}
                {cell.status}{" "}
              </span>
            );
          case "Closed":
            return (
              <span className="badge badge-soft-danger"> {cell.status} </span>
            );
          case "Inprogress":
            return (
              <span className="badge badge-soft-warning"> {cell.status} </span>
            );
          case "Open":
            return (
              <span className="badge badge-soft-primary"> {cell.status} </span>
            );
          case "New":
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Priority</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.priority) {
          case "High":
            return <span className="badge bg-danger"> {cell.priority} </span>;
          case "Medium":
            return <span className="badge bg-info"> {cell.priority} </span>;
          case "Low":
            return <span className="badge bg-success"> {cell.priority} </span>;
          default:
            return <span className="badge bg-danger"> {cell.priority} </span>;
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Action</span>,
      sortable: true,

      cell: () => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-soft-secondary btn-sm"
              tag="button"
            >
              <i className="ri-more-fill align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem href="#!">
                <i className="ri-eye-fill align-bottom me-2 text-muted"></i>View
              </DropdownItem>
              <DropdownItem className="edit-item-btn">
                <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                Edit
              </DropdownItem>
              <DropdownItem className="remove-item-btn">
                {" "}
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                Delete{" "}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const data = [
    {
      srNo: "01",
      id: "VLZ-452",
      purchaseId: "VLZ1400087402",
      title: "Post launch reminder/ post list",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "03 Oct, 2021",
      status: "Re-open",
      priority: "High",
    },
    {
      srNo: "02",
      id: "VLZ-453",
      purchaseId: "VLZ1400087425",
      title: "Additional Calendar",
      user: "Diana Kohler",
      assigned: "Admin",
      createdBy: "Mary Rucker",
      createDate: "05 Oct, 2021",
      status: "On-Hold",
      priority: "Medium",
    },
    {
      srNo: "03",
      id: "VLZ-454",
      purchaseId: "VLZ1400087438",
      title: "Make a creating an account profile",
      user: "Tonya Noble",
      assigned: "Admin",
      createdBy: "Tonya Noble",
      createDate: "27 April, 2022",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "04",
      id: "VLZ-455",
      purchaseId: "VLZ1400087748",
      title: "Apologize for shopping Error!",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "14 June, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "05",
      id: "VLZ-456",
      purchaseId: "VLZ1400087547",
      title: "Support for theme",
      user: "Donald Palmer",
      assigned: "Admin",
      createdBy: "Donald Palmer",
      createDate: "25 June, 2021",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "06",
      id: "VLZ-457",
      purchaseId: "VLZ1400087245",
      title: "Benner design for FB & Twitter",
      user: "Mary Rucker",
      assigned: "Jennifer Carter",
      createdBy: "Mary Rucker",
      createDate: "14 Aug, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "07",
      id: "VLZ-458",
      purchaseId: "VLZ1400087785",
      title: "Change email option process",
      user: "James Morris",
      assigned: "Admin",
      createdBy: "James Morris",
      createDate: "12 March, 2022",
      status: "Open",
      priority: "High",
    },
    {
      srNo: "08",
      id: "VLZ-460",
      purchaseId: "VLZ1400087745",
      title: "Support for theme",
      user: "Nathan Cole",
      assigned: "Nancy Martino",
      createdBy: "Nathan Cole",
      createDate: "28 Feb, 2022",
      status: "On-Hold",
      priority: "Low",
    },
    {
      srNo: "09",
      id: "VLZ-461",
      purchaseId: "VLZ1400087179",
      title: "Form submit issue",
      user: "Grace Coles",
      assigned: "Admin",
      createdBy: "Grace Coles",
      createDate: "07 Jan, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "10",
      id: "VLZ-462",
      purchaseId: "VLZ140008856",
      title: "Edit customer testimonial",
      user: "Freda",
      assigned: "Alexis Clarke",
      createdBy: "Freda",
      createDate: "16 Aug, 2021",
      status: "Closed",
      priority: "Medium",
    },
  ];
  return <DataTable columns={columns} data={data} pagination />;
};

const ScrollVertical = () => {
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">ID</span>,
      selector: (row) => row.ScrVerId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Project</span>,
      selector: (row) => row.project,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Task</span>,
      selector: (row) => <Link to="#!">{row.task}</Link>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Client Name</span>,
      selector: (row) => row.clientName,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Assigned To</span>,
      sortable: true,
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="avatar-group">
              {cell.assigned.map((item, index) => (
                <Link key={index} to="#" className="avatar-group-item">
                  <img src={item} alt="" className="rounded-circle avatar-xs" />
                </Link>
              ))}
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Due Date</span>,
      selector: (row) => row.dueDate,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.status) {
          case "Re-open":
            return (
              <span className="badge badge-soft-info"> {cell.status} </span>
            );
          case "On-Hold":
            return (
              <span className="badge badge-soft-secondary">
                {" "}
                {cell.status}{" "}
              </span>
            );
          case "Closed":
            return (
              <span className="badge badge-soft-danger"> {cell.status} </span>
            );
          case "Inprogress":
            return (
              <span className="badge badge-soft-warning"> {cell.status} </span>
            );
          case "Open":
            return (
              <span className="badge badge-soft-primary"> {cell.status} </span>
            );
          case "New":
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Priority</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.priority) {
          case "High":
            return <span className="badge bg-danger"> {cell.priority} </span>;
          case "Medium":
            return <span className="badge bg-info"> {cell.priority} </span>;
          case "Low":
            return <span className="badge bg-success"> {cell.priority} </span>;
          default:
            return <span className="badge bg-danger"> {cell.priority} </span>;
        }
      },
    },
  ];

  const data = [
    {
      ScrVerId: "VLZ-452",
      project: "Symox v1.0.0",
      task: "Add Dynamic Contact List",
      clientName: "RH Nichols",
      assigned: [avatar3],
      dueDate: "03 Oct, 2021",
      status: "Re-open",
      priority: "High",
    },
    {
      ScrVerId: "VLZ-453",
      project: "Doot - Chat App Template",
      task: "Additional Calendar",
      clientName: "Diana Kohler",
      assigned: [avatar4, avatar5],
      dueDate: "05 Oct, 2021",
      status: "On-Hold",
      priority: "Medium",
    },
    {
      ScrVerId: "VLZ-454",
      project: "Qexal - Landing Page",
      task: "Make a creating an account profile",
      clientName: "David Nichols",
      assigned: [avatar6, avatar7, avatar8],
      dueDate: "27 April, 2022",
      status: "Closed",
      priority: "Low",
    },
    {
      ScrVerId: "VLZ-455",
      project: "Dorsin - Landing Page",
      task: "Apologize for shopping Error!",
      clientName: "Tonya Noble",
      assigned: [avatar6, avatar7],
      dueDate: "14 June, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      ScrVerId: "VLZ-456",
      project: "Minimal - v2.1.0",
      task: "Support for theme",
      clientName: "Donald Palmer",
      assigned: [avatar2],
      dueDate: "25 June, 2021",
      status: "Closed",
      priority: "Low",
    },
    {
      ScrVerId: "VLZ-457",
      project: "Dason - v1.0.0",
      task: "Benner design for FB & Twitter",
      clientName: "Jennifer Carter",
      assigned: [avatar5, avatar6, avatar7, avatar8],
      dueDate: "14 Aug, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      ScrVerId: "VLZ-458",
      project: "Velzon v1.6.0",
      task: "Add datatables",
      clientName: "James Morris",
      assigned: [avatar4, avatar5],
      dueDate: "12 March, 2022",
      status: "Open",
      priority: "High",
    },
    {
      ScrVerId: "VLZ-460",
      project: "Skote v2.0.0",
      task: "Support for theme",
      clientName: "Nancy Martino",
      assigned: [avatar3, avatar10, avatar9],
      dueDate: "28 Feb, 2022",
      status: "On-Hold",
      priority: "Low",
    },
    {
      ScrVerId: "VLZ-461",
      project: "Velzon v1.0.0",
      task: "Form submit issue",
      clientName: "Grace Coles",
      assigned: [avatar5, avatar10, avatar9],
      dueDate: "07 Jan, 2022",
      status: "New",
      priority: "High",
    },
    {
      ScrVerId: "VLZ-462",
      project: "Minimal - v2.2.0",
      task: "Edit customer testimonial",
      clientName: "Freda",
      assigned: [avatar2],
      dueDate: "16 Aug, 2021",
      status: "Closed",
      priority: "Medium",
    },
    {
      ScrVerId: "VLZ-454",
      project: "Qexal - Landing Page",
      task: "Make a creating an account profile",
      clientName: "David Nichols",
      assigned: [avatar6, avatar7, avatar8],
      dueDate: "27 April, 2022",
      status: "Closed",
      priority: "Low",
    },
    {
      ScrVerId: "VLZ-455",
      project: "Dorsin - Landing Page",
      task: "Apologize for shopping Error!",
      clientName: "Tonya Noble",
      assigned: [avatar6, avatar7],
      dueDate: "14 June, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      ScrVerId: "VLZ-456",
      project: "Minimal - v2.1.0",
      task: "Support for theme",
      clientName: "Donald Palmer",
      assigned: [avatar2],
      dueDate: "25 June, 2021",
      status: "Closed",
      priority: "Low",
    },
    {
      ScrVerId: "VLZ-457",
      project: "Dason - v1.0.0",
      task: "Benner design for FB & Twitter",
      clientName: "Jennifer Carter",
      assigned: [avatar5, avatar6, avatar7, avatar8],
      dueDate: "14 Aug, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
  ];
  return (
    <DataTable
      fixedHeader
      fixedHeaderScrollHeight="300px"
      columns={columns}
      data={data}
    />
  );
};

const ScrollHorizontal = () => {
  const columns = [
    {
      name: (
        <Input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
      cell: () => (
        <input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">SR No.</span>,
      selector: (row) => row.srNo,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">ID</span>,
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Purchase ID</span>,
      selector: (row) => row.purchaseId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Title</span>,
      selector: (row) => <Link to="#!">{row.title}</Link>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">User</span>,
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Assigned To</span>,
      selector: (row) => row.assigned,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create By</span>,
      selector: (row) => row.createdBy,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create Date</span>,
      selector: (row) => row.createDate,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.status) {
          case "Re-open":
            return (
              <span className="badge badge-soft-info"> {cell.status} </span>
            );
          case "On-Hold":
            return (
              <span className="badge badge-soft-secondary">
                {" "}
                {cell.status}{" "}
              </span>
            );
          case "Closed":
            return (
              <span className="badge badge-soft-danger"> {cell.status} </span>
            );
          case "Inprogress":
            return (
              <span className="badge badge-soft-warning"> {cell.status} </span>
            );
          case "Open":
            return (
              <span className="badge badge-soft-primary"> {cell.status} </span>
            );
          case "New":
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Priority</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.priority) {
          case "High":
            return <span className="badge bg-danger"> {cell.priority} </span>;
          case "Medium":
            return <span className="badge bg-info"> {cell.priority} </span>;
          case "Low":
            return <span className="badge bg-success"> {cell.priority} </span>;
          default:
            return <span className="badge bg-danger"> {cell.priority} </span>;
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Action</span>,
      sortable: true,
      cell: () => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-soft-secondary btn-sm"
              tag="button"
            >
              <i className="ri-more-fill align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem href="#!">
                <i className="ri-eye-fill align-bottom me-2 text-muted"></i>View
              </DropdownItem>
              <DropdownItem className="edit-item-btn">
                <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                Edit
              </DropdownItem>
              <DropdownItem className="remove-item-btn">
                {" "}
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                Delete{" "}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const data = [
    {
      srNo: "01",
      id: "VLZ-452",
      purchaseId: "VLZ1400087402",
      title: "Post launch reminder/ post list",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "03 Oct, 2021",
      status: "Re-open",
      priority: "High",
    },
    {
      srNo: "02",
      id: "VLZ-453",
      purchaseId: "VLZ1400087425",
      title: "Additional Calendar",
      user: "Diana Kohler",
      assigned: "Admin",
      createdBy: "Mary Rucker",
      createDate: "05 Oct, 2021",
      status: "On-Hold",
      priority: "Medium",
    },
    {
      srNo: "03",
      id: "VLZ-454",
      purchaseId: "VLZ1400087438",
      title: "Make a creating an account profile",
      user: "Tonya Noble",
      assigned: "Admin",
      createdBy: "Tonya Noble",
      createDate: "27 April, 2022",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "04",
      id: "VLZ-455",
      purchaseId: "VLZ1400087748",
      title: "Apologize for shopping Error!",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "14 June, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "05",
      id: "VLZ-456",
      purchaseId: "VLZ1400087547",
      title: "Support for theme",
      user: "Donald Palmer",
      assigned: "Admin",
      createdBy: "Donald Palmer",
      createDate: "25 June, 2021",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "07",
      id: "VLZ-458",
      purchaseId: "VLZ1400087785",
      title: "Change email option process",
      user: "James Morris",
      assigned: "Admin",
      createdBy: "James Morris",
      createDate: "12 March, 2022",
      status: "Open",
      priority: "High",
    },
    {
      srNo: "08",
      id: "VLZ-460",
      purchaseId: "VLZ1400087745",
      title: "Support for theme",
      user: "Nathan Cole",
      assigned: "Nancy Martino",
      createdBy: "Nathan Cole",
      createDate: "28 Feb, 2022",
      status: "On-Hold",
      priority: "Low",
    },
    {
      srNo: "09",
      id: "VLZ-461",
      purchaseId: "VLZ1400087179",
      title: "Form submit issue",
      user: "Grace Coles",
      assigned: "Admin",
      createdBy: "Grace Coles",
      createDate: "07 Jan, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "10",
      id: "VLZ-462",
      purchaseId: "VLZ140008856",
      title: "Edit customer testimonial",
      user: "Freda",
      assigned: "Alexis Clarke",
      createdBy: "Freda",
      createDate: "16 Aug, 2021",
      status: "Closed",
      priority: "Medium",
    },
    {
      srNo: "11",
      id: "VLZ-463",
      purchaseId: "VLZ1400078031",
      title: "Ca i have an e-copy invoice",
      user: "Williams",
      assigned: "Admin",
      createdBy: "Williams",
      createDate: "24 Feb, 2022",
      status: "Open",
      priority: "Low",
    },
    {
      srNo: "12",
      id: "VLZ-464",
      purchaseId: "VLZ1400087416",
      title: "Brand logo design",
      user: "Richard V.",
      assigned: "Admin",
      createdBy: "Richard V.",
      createDate: "16 March, 2021",
      status: "Inprogress",
      priority: "High",
    },
    {
      srNo: "13",
      id: "VLZ-466",
      purchaseId: "VLZ1400089015",
      title: "Issue with finding information about order ?",
      user: "Olive Gunther",
      assigned: "Alexis Clarke",
      createdBy: "Schaefer",
      createDate: "32 March, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "14",
      id: "VLZ-467",
      purchaseId: "VLZ1400090324",
      title: "Make a creating an account profile",
      user: "Edwin",
      assigned: "Admin",
      createdBy: "Edwin",
      createDate: "05 April, 2022",
      status: "Inprogress",
      priority: "Low",
    },
  ];
  return <DataTable columns={columns} data={data} pagination />;
};

const AlternativePagination = () => {
  const columns = [
    {
      name: <span className="font-weight-bold fs-13">SR No.</span>,
      selector: (row) => row.srNo,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Currency</span>,
      sortable: true,
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium">
              <img src={cell.currency[0]} alt="" className="avatar-xs me-2" />
              <Link to="#" className="currency_name">
                {cell.currency[1]}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Price</span>,
      selector: (row) => row.price,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Pairs</span>,
      selector: (row) => row.pairs,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">24 High</span>,
      selector: (row) => row.high,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">24 Low</span>,
      selector: (row) => row.low,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Market Volume</span>,
      selector: (row) => row.marketVolume,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Volume %</span>,
      sortable: true,
      selector: (cell) => {
        return (
          <h6 className={"fs-13 mb-0 text-" + cell.volumeClass}>
            {" "}
            <i className={"align-middle me-1 " + cell.icon}></i>
            {cell.volume}
          </h6>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Action</span>,
      sortable: true,
      cell: () => {
        return <button className="btn btn-sm btn-soft-info">Trade Now</button>;
      },
    },
  ];

  const data = [
    {
      srNo: "01",
      currency: [btc, "Bitcoin (BTC)"],
      price: "$47,071.60",
      pairs: "BTC/USD",
      high: "$28,722.76",
      low: "$68,789.63",
      marketVolume: "$888,411,910",
      volume: "1.50%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "02",
      currency: [eth, "Ethereum (ETH)"],
      price: "$3,813.14",
      pairs: "ETH/USDT",
      high: "$4,036.24",
      low: "$3,588.14",
      marketVolume: "$314,520,675",
      volume: "0.42%",
      icon: "mdi mdi-trending-down",
      volumeClass: "danger",
    },
    {
      srNo: "03",
      currency: [ltc, "Litecoin (LTC)"],
      price: "$149.65",
      pairs: "LTC/USDT",
      high: "$412.96",
      low: "$104.33",
      marketVolume: "$314,520,675",
      volume: "0.89%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "04",
      currency: [xmr, "Monero (XMR)"],
      price: "$17,491.16",
      pairs: "XRM/USDT",
      high: "$31,578.35",
      low: "$8691.75",
      marketVolume: "$9,847,327",
      volume: "1.92%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "05",
      currency: [ant, "Aragon (ANT)"],
      price: "$172.93",
      pairs: "SOL/USD",
      high: "$178.37",
      low: "$172.3",
      marketVolume: "$40,559,274",
      volume: "2.87%",
      icon: "mdi mdi-trending-down",
      volumeClass: "danger",
    },
    {
      srNo: "06",
      currency: [sol, "Solana (SOL)"],
      price: "$17,491.16",
      pairs: "XRM/USDT",
      high: "$31,578.35",
      low: "$8691.75",
      marketVolume: "$9,847,327",
      volume: "1.92%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "07",
      currency: [fil, "Filecoin (FIL)"],
      price: "$13.31",
      pairs: "ANT/USD",
      high: "$13.85",
      low: "$12.53",
      marketVolume: "$156,209,195.18",
      volume: "3.96%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "08",
      currency: [fil, "Filecoin (FIL)"],
      price: "$35.21",
      pairs: "FIL/USD",
      high: "$36.41",
      low: "$35.03",
      marketVolume: "$374,618,945.51",
      volume: "0.84%",
      icon: "mdi mdi-trending-down",
      volumeClass: "danger",
    },
    {
      srNo: "09",
      currency: [aave, "Aave (AAVE)"],
      price: "$275.47",
      pairs: "AAVE/USDT",
      high: "$277.11",
      low: "$255.01",
      marketVolume: "$156,209,195.18",
      volume: "8.20%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "10",
      currency: [ada, "Cardano (ADA)"],
      price: "$1.35",
      pairs: "ADA/USD",
      high: "$1.39",
      low: "$1.32",
      marketVolume: "$880,387,980.14",
      volume: "0.42%",
      icon: "mdi mdi-trending-down",
      volumeClass: "danger",
    },
    {
      srNo: "11",
      currency: [fil, "Filecoin (FIL)"],
      price: "$35.21",
      pairs: "FIL/USD",
      high: "$36.41",
      low: "$35.03",
      marketVolume: "$374,618,945.51",
      volume: "0.84%",
      icon: "mdi mdi-trending-down",
      volumeClass: "danger",
    },
    {
      srNo: "12",
      currency: [aave, "Aave (AAVE)"],
      price: "$275.47",
      pairs: "AAVE/USDT",
      high: "$277.11",
      low: "$255.01",
      marketVolume: "$156,209,195.18",
      volume: "8.20%",
      icon: "mdi mdi-trending-up",
      volumeClass: "success",
    },
    {
      srNo: "13",
      currency: [ada, "Cardano (ADA)"],
      price: "$1.35",
      pairs: "ADA/USD",
      high: "$1.39",
      low: "$1.32",
      marketVolume: "$880,387,980.14",
      volume: "0.42%",
      icon: "mdi mdi-trending-down",
      volumeClass: "danger",
    },
  ];
  return <DataTable columns={columns} data={data} pagination />;
};

const FixedHeaderDatatables = () => {
  const columns = [
    {
      name: (
        <Input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
      cell: () => (
        <input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">SR No.</span>,
      selector: (row) => row.srNo,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">ID</span>,
      selector: (row) => row.FixHeadId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Purchase ID</span>,
      selector: (row) => row.purchaseId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Title</span>,
      selector: (row) => <Link to="#!">{row.title}</Link>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">User</span>,
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Assigned To</span>,
      selector: (row) => row.assigned,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create By</span>,
      selector: (row) => row.createdBy,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create Date</span>,
      selector: (row) => row.createDate,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.status) {
          case "Re-open":
            return (
              <span className="badge badge-soft-info"> {cell.status} </span>
            );
          case "On-Hold":
            return (
              <span className="badge badge-soft-secondary">
                {" "}
                {cell.status}{" "}
              </span>
            );
          case "Closed":
            return (
              <span className="badge badge-soft-danger"> {cell.status} </span>
            );
          case "Inprogress":
            return (
              <span className="badge badge-soft-warning"> {cell.status} </span>
            );
          case "Open":
            return (
              <span className="badge badge-soft-primary"> {cell.status} </span>
            );
          case "New":
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Priority</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.priority) {
          case "High":
            return <span className="badge bg-danger"> {cell.priority} </span>;
          case "Medium":
            return <span className="badge bg-info"> {cell.priority} </span>;
          case "Low":
            return <span className="badge bg-success"> {cell.priority} </span>;
          default:
            return <span className="badge bg-danger"> {cell.priority} </span>;
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Action</span>,
      sortable: true,

      cell: () => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-soft-secondary btn-sm"
              tag="button"
            >
              <i className="ri-more-fill align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem href="#!">
                <i className="ri-eye-fill align-bottom me-2 text-muted"></i>View
              </DropdownItem>
              <DropdownItem className="edit-item-btn">
                <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                Edit
              </DropdownItem>
              <DropdownItem className="remove-item-btn">
                {" "}
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                Delete{" "}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const data = [
    {
      srNo: "01",
      FixHeadId: "VLZ-452",
      purchaseId: "VLZ1400087402",
      title: "Post launch reminder/ post list",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "03 Oct, 2021",
      status: "Re-open",
      priority: "High",
    },
    {
      srNo: "02",
      FixHeadId: "VLZ-453",
      purchaseId: "VLZ1400087425",
      title: "Additional Calendar",
      user: "Diana Kohler",
      assigned: "Admin",
      createdBy: "Mary Rucker",
      createDate: "05 Oct, 2021",
      status: "On-Hold",
      priority: "Medium",
    },
    {
      srNo: "03",
      FixHeadId: "VLZ-454",
      purchaseId: "VLZ1400087438",
      title: "Make a creating an account profile",
      user: "Tonya Noble",
      assigned: "Admin",
      createdBy: "Tonya Noble",
      createDate: "27 April, 2022",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "04",
      FixHeadId: "VLZ-455",
      purchaseId: "VLZ1400087748",
      title: "Apologize for shopping Error!",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "14 June, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "05",
      FixHeadId: "VLZ-456",
      purchaseId: "VLZ1400087547",
      title: "Support for theme",
      user: "Donald Palmer",
      assigned: "Admin",
      createdBy: "Donald Palmer",
      createDate: "25 June, 2021",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "06",
      FixHeadId: "VLZ-457",
      purchaseId: "VLZ1400087245",
      title: "Benner design for FB & Twitter",
      user: "Mary Rucker",
      assigned: "Jennifer Carter",
      createdBy: "Mary Rucker",
      createDate: "14 Aug, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "07",
      FixHeadId: "VLZ-458",
      purchaseId: "VLZ1400087785",
      title: "Change email option process",
      user: "James Morris",
      assigned: "Admin",
      createdBy: "James Morris",
      createDate: "12 March, 2022",
      status: "Open",
      priority: "High",
    },
    {
      srNo: "08",
      FixHeadId: "VLZ-460",
      purchaseId: "VLZ1400087745",
      title: "Support for theme",
      user: "Nathan Cole",
      assigned: "Nancy Martino",
      createdBy: "Nathan Cole",
      createDate: "28 Feb, 2022",
      status: "On-Hold",
      priority: "Low",
    },
    {
      srNo: "09",
      FixHeadId: "VLZ-461",
      purchaseId: "VLZ1400087179",
      title: "Form submit issue",
      user: "Grace Coles",
      assigned: "Admin",
      createdBy: "Grace Coles",
      createDate: "07 Jan, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "10",
      FixHeadId: "VLZ-462",
      purchaseId: "VLZ140008856",
      title: "Edit customer testimonial",
      user: "Freda",
      assigned: "Alexis Clarke",
      createdBy: "Freda",
      createDate: "16 Aug, 2021",
      status: "Closed",
      priority: "Medium",
    },
    {
      srNo: "11",
      FixHeadId: "VLZ-463",
      purchaseId: "VLZ1400078031",
      title: "Ca i have an e-copy invoice",
      user: "Williams",
      assigned: "Admin",
      createdBy: "Williams",
      createDate: "24 Feb, 2022",
      status: "Open",
      priority: "Low",
    },
    {
      srNo: "12",
      FixHeadId: "VLZ-464",
      purchaseId: "VLZ1400087416",
      title: "Brand logo design",
      user: "Richard V.",
      assigned: "Admin",
      createdBy: "Richard V.",
      createDate: "16 March, 2021",
      status: "Inprogress",
      priority: "High",
    },
    {
      srNo: "13",
      FixHeadId: "VLZ-466",
      purchaseId: "VLZ1400089015",
      title: "Issue with finding information about order ?",
      user: "Olive Gunther",
      assigned: "Alexis Clarke",
      createdBy: "Schaefer",
      createDate: "32 March, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "14",
      FixHeadId: "VLZ-467",
      purchaseId: "VLZ1400090324",
      title: "Make a creating an account profile",
      user: "Edwin",
      assigned: "Admin",
      createdBy: "Edwin",
      createDate: "05 April, 2022",
      status: "Inprogress",
      priority: "Low",
    },
  ];
  return <DataTable columns={columns} data={data} pagination />;
};

const ModalDataDatatables = () => {
  const columns = [
    {
      name: (
        <Input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
      cell: () => (
        <input
          className="form-check-input fs-15"
          type="checkbox"
          name="checkAll"
          value="option1"
        />
      ),
    },
    {
      name: <span className="font-weight-bold fs-13">SR No.</span>,
      selector: (row) => row.srNo,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">ID</span>,
      selector: (row) => row.modalId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Purchase ID</span>,
      selector: (row) => row.purchaseId,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Title</span>,
      selector: (row) => <Link to="#!">{row.title}</Link>,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">User</span>,
      selector: (row) => row.user,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Assigned To</span>,
      selector: (row) => row.assigned,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create By</span>,
      selector: (row) => row.createdBy,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Create Date</span>,
      selector: (row) => row.createDate,
      sortable: true,
    },
    {
      name: <span className="font-weight-bold fs-13">Status</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.status) {
          case "Re-open":
            return (
              <span className="badge badge-soft-info"> {cell.status} </span>
            );
          case "On-Hold":
            return (
              <span className="badge badge-soft-secondary">
                {" "}
                {cell.status}{" "}
              </span>
            );
          case "Closed":
            return (
              <span className="badge badge-soft-danger"> {cell.status} </span>
            );
          case "Inprogress":
            return (
              <span className="badge badge-soft-warning"> {cell.status} </span>
            );
          case "Open":
            return (
              <span className="badge badge-soft-primary"> {cell.status} </span>
            );
          case "New":
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
          default:
            return (
              <span className="badge badge-soft-success"> {cell.status} </span>
            );
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Priority</span>,
      sortable: true,
      selector: (cell) => {
        switch (cell.priority) {
          case "High":
            return <span className="badge bg-danger"> {cell.priority} </span>;
          case "Medium":
            return <span className="badge bg-info"> {cell.priority} </span>;
          case "Low":
            return <span className="badge bg-success"> {cell.priority} </span>;
          default:
            return <span className="badge bg-danger"> {cell.priority} </span>;
        }
      },
    },
    {
      name: <span className="font-weight-bold fs-13">Action</span>,
      sortable: true,

      cell: () => {
        return (
          <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle
              className="btn btn-soft-secondary btn-sm"
              tag="button"
            >
              <i className="ri-more-fill align-middle"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              <DropdownItem href="#!">
                <i className="ri-eye-fill align-bottom me-2 text-muted"></i>View
              </DropdownItem>
              <DropdownItem className="edit-item-btn">
                <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>
                Edit
              </DropdownItem>
              <DropdownItem className="remove-item-btn">
                {" "}
                <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                Delete{" "}
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];
  const data = [
    {
      srNo: "01",
      modalId: "VLZ-452",
      purchaseId: "VLZ1400087402",
      title: "Post launch reminder/ post list",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "03 Oct, 2021",
      status: "Re-open",
      priority: "High",
    },
    {
      srNo: "02",
      modalId: "VLZ-453",
      purchaseId: "VLZ1400087425",
      title: "Additional Calendar",
      user: "Diana Kohler",
      assigned: "Admin",
      createdBy: "Mary Rucker",
      createDate: "05 Oct, 2021",
      status: "On-Hold",
      priority: "Medium",
    },
    {
      srNo: "03",
      modalId: "VLZ-454",
      purchaseId: "VLZ1400087438",
      title: "Make a creating an account profile",
      user: "Tonya Noble",
      assigned: "Admin",
      createdBy: "Tonya Noble",
      createDate: "27 April, 2022",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "04",
      modalId: "VLZ-455",
      purchaseId: "VLZ1400087748",
      title: "Apologize for shopping Error!",
      user: "Joseph Parker",
      assigned: "Alexis Clarke",
      createdBy: "Joseph Parker",
      createDate: "14 June, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "05",
      modalId: "VLZ-456",
      purchaseId: "VLZ1400087547",
      title: "Support for theme",
      user: "Donald Palmer",
      assigned: "Admin",
      createdBy: "Donald Palmer",
      createDate: "25 June, 2021",
      status: "Closed",
      priority: "Low",
    },
    {
      srNo: "06",
      modalId: "VLZ-457",
      purchaseId: "VLZ1400087245",
      title: "Benner design for FB & Twitter",
      user: "Mary Rucker",
      assigned: "Jennifer Carter",
      createdBy: "Mary Rucker",
      createDate: "14 Aug, 2021",
      status: "Inprogress",
      priority: "Medium",
    },
    {
      srNo: "07",
      modalId: "VLZ-458",
      purchaseId: "VLZ1400087785",
      title: "Change email option process",
      user: "James Morris",
      assigned: "Admin",
      createdBy: "James Morris",
      createDate: "12 March, 2022",
      status: "Open",
      priority: "High",
    },
    {
      srNo: "08",
      modalId: "VLZ-460",
      purchaseId: "VLZ1400087745",
      title: "Support for theme",
      user: "Nathan Cole",
      assigned: "Nancy Martino",
      createdBy: "Nathan Cole",
      createDate: "28 Feb, 2022",
      status: "On-Hold",
      priority: "Low",
    },
    {
      srNo: "09",
      modalId: "VLZ-461",
      purchaseId: "VLZ1400087179",
      title: "Form submit issue",
      user: "Grace Coles",
      assigned: "Admin",
      createdBy: "Grace Coles",
      createDate: "07 Jan, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "10",
      modalId: "VLZ-462",
      purchaseId: "VLZ140008856",
      title: "Edit customer testimonial",
      user: "Freda",
      assigned: "Alexis Clarke",
      createdBy: "Freda",
      createDate: "16 Aug, 2021",
      status: "Closed",
      priority: "Medium",
    },
    {
      srNo: "11",
      modalId: "VLZ-463",
      purchaseId: "VLZ1400078031",
      title: "Ca i have an e-copy invoice",
      user: "Williams",
      assigned: "Admin",
      createdBy: "Williams",
      createDate: "24 Feb, 2022",
      status: "Open",
      priority: "Low",
    },
    {
      srNo: "12",
      modalId: "VLZ-464",
      purchaseId: "VLZ1400087416",
      title: "Brand logo design",
      user: "Richard V.",
      assigned: "Admin",
      createdBy: "Richard V.",
      createDate: "16 March, 2021",
      status: "Inprogress",
      priority: "High",
    },
    {
      srNo: "13",
      modalId: "VLZ-466",
      purchaseId: "VLZ1400089015",
      title: "Issue with finding information about order ?",
      user: "Olive Gunther",
      assigned: "Alexis Clarke",
      createdBy: "Schaefer",
      createDate: "32 March, 2022",
      status: "New",
      priority: "High",
    },
    {
      srNo: "14",
      modalId: "VLZ-467",
      purchaseId: "VLZ1400090324",
      title: "Make a creating an account profile",
      user: "Edwin",
      assigned: "Admin",
      createdBy: "Edwin",
      createDate: "05 April, 2022",
      status: "Inprogress",
      priority: "Low",
    },
  ];
  return <DataTable columns={columns} data={data} pagination />;
};

const GroupDatatables = ({
  groupByKey = null,
  Codigo_Produto_Revenda = null,
  Ano = null,
  Mes = null,
  ID_Empresa_Parceiro = null,
  ID_Empresa_Revenda = null,
  Data_Inicial = null,
  Data_Final = null,
  Zona = null,
  ID_Planta = null,
  UF = null,
  paginator = true,
  Nivel = 0,
  Visao = "SKU",
  ID_Consulta = 0,
  paddingLeft = 10,
  filterEmpresa = null
}) => {

  console.log("Visao: ", Visao)

  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.user,
  }));
  
  const [isLoading, setIsLoading] = useState(false)
  const [productList, setProductList] = useState([]);
  const [columnsList, setColumnsList] = useState([]);
  const [resultset2, setResultset2] = useState();
  const [totalRecords, setTotalRecords] = useState();
  const [CodigoProdutoRevenda, setCodigoProdutoRevenda] = useState(Codigo_Produto_Revenda);
  const [uf, setUf] = useState(UF);
  const [idEmpresaRevenda, setIdEmpresaRevenda] = useState(ID_Empresa_Revenda);
  const [idEmpresaParceiro, setIdEmpresaParceiro] = useState(ID_Empresa_Parceiro);
  const [dataFinal, setDataFinal] = useState(Data_Final);
  const [dataInicial, setDataInicial] = useState(Data_Inicial);
  const [zona, setZona] = useState(Zona);
  const [idPlanta, setIdPlanta] = useState(ID_Planta);
  const [ano, setAno] = useState(Ano);
  const [mes, setMes] = useState(Mes);
  const [cookies] = useCookies(["_csrf_token"]);
  const [dataKey, setDataKey] = useState("Codigo_Produto_Revenda");
  const [idConsulta, setIdConsulta] = useState(ID_Consulta);
  const [messageError, setMessageError] = useState(null);
  const [expandedRows, setExpandedRows] = useState({});

  // modelo - Array de objetos dinâmico de colunas = [
  // {
  //   field: "codigo_original",
  //   header: "Codigo_Original",
  //   body: (rowData) => genericComponent(rowData, "codigo_original", true),
  // },
  //  { field: "nome_resumido", header: "Nome_Resumido" },
  //  { field: "cnpj", header: "CPNJ", body: (rowData) => priceBodyTemplate(rowData, false) },
  //  { field: "anos", header: "Anos"},
  //  { field: "trimestre", header: "Trimestre"},
  //  { field: "meses", header: "Meses"},
  //  { field: "nome_produto", header: "Nome_Produto"},
  //  { field: "qtd_skus", header: "QTD. Skus (total)"},
  //  { field: "qtd_vendida", header: "QTD. Vendida (total)", body: rowData => genericComponent(rowData, "qtd_vendida", false)},
  //  { field: "total", header: "Total"},
  // ];

  // Após uma coluna ser expandida, esta função renderizará o conteúdo
  const rowExpansionTemplate = (data) => {
    return (
      <GroupDatatables
        paginator={false}
        Codigo_Produto_Revenda={CodigoProdutoRevenda}
        UF={uf}
        ID_Empresa_Revenda={idEmpresaRevenda}
        Ano={ano}
        Mes={mes}
        groupByKey={data?.groupByKey}
        Data_Final={dataFinal}
        Data_Inicial={dataInicial}
        ID_Consulta={idConsulta}
        Nivel={Nivel+1}
        ID_Empresa_Parceiro={idEmpresaParceiro}
        key={Nivel+1}
        ID_Planta={idPlanta}
        Zona={zona}
        paddingLeft={paddingLeft+10}
      />
    );
  };

  //(não remover) - essa função é usada quando o backend trás informações das colunas
  const genericComponent = (rowData, field, expander = false) => {
    let fieldName = rowData[field];
    return (
      <div className="d-flex gap-2 align-items-center">
        {expander && rowData.isExpanded == "S" && (
          <button
            onClick={() => expandItem(rowData, field)}
            type="button"
            className="btn p-0 m-0 d-flex align-items-center"
          >
            <i
              className={`font-size-20 text-secondary fas fa-caret-${
                expandedRows[rowData[field]] ? "down" : "right"
              }`}
            ></i>
          </button>
        )}
        <span>{fieldName}</span>
      </div>
    );
  };

  // Função customiza - responsável por identificar o evento de expansão da coluna
  const expandItem = (rowData, field) => {
    let _expandedRows = {};

    // Alterar esse *SWITCH*, conforme a regra da tabela
    switch (field) {
      case "Codigo_Produto_Revenda":
        if (rowData?.Codigo_Produto_Revenda) setCodigoProdutoRevenda(rowData.Codigo_Produto_Revenda);
        break;
      case "UF":
        if (rowData.UF) setUf(rowData.UF);
        break;
      case "Ano":
        if (rowData.Ano) setAno(rowData.Ano);
        break;
      case "Revenda":
        if (rowData.ID_Empresa) setIdEmpresaRevenda(rowData.ID_Empresa);
        break;
      case "Descricao_Zona":
        if (rowData.ID_Zona) setZona(rowData.ID_Zona);
        break;
      case "Mes_Descricao":
        if (rowData.Mes) setMes(rowData.Mes);
        break;
    }
    // end

    setDataKey(field);

    productList.forEach((p) =>
      rowData[field] == p[field]
        ? (_expandedRows[p[field]] = expandedRows[p[field]] ? false : true)
        : (_expandedRows[p[field]] = false)
    );

    setExpandedRows(
      Object.keys(_expandedRows)
        .filter((key) => _expandedRows[key])
        .reduce((res, key) => ((res[key] = _expandedRows[key]), res), {})
    );
  };

  // Função responsável por buscar os dados no backend
  const getDataOnExpandedRow = () => {
    setIsLoading(!isLoading)
    axios
      .post(
        `${config.URL_SERVER}/execute-procedure`,
        {
          proc: "VENDA_SEGURA_Obter_Dados_Sellout",
          requestData: {
            1: userProfile?.resultset_2[0].ID_Usuario || 0, //ID_Usuario
            2: ID_Consulta, // ID_Consulta
            3: filterEmpresa, //Filter_Empresa_Revenda
            4: "1386,884,103", // ID_Empresa_Parceiro
            5: "20240101", //Data_Inicial	(datetime)
            6: "20250101", //Data_Final (datetime)
            7: Visao, //visao
            8: Nivel, //Nivel
            9: Codigo_Produto_Revenda, //Param_Codigo_Produto_Revenda
            10: Ano, //Param_Ano
            11: Mes, //Param_Mes
            12: ID_Empresa_Revenda, //Param_ID_Empresa_Revenda
            13: ID_Empresa_Parceiro, //Param_ID_Empresa_Parceiro
            14: UF, //Param_UF
            15: Zona, //Param_Zona
            16: ID_Planta, //Param_ID_Planta
          },
        },
        {
          headers: {
            "X-CSRF-Token": cookies._csrf_token.csrfToken,
          },
        }
      )
      .then(({ data }) => {
        setIsLoading(false)
        console.log(data);
        setMessageError(null);
        if (data?.resultset_2 && data?.resultset_1) {
          setProductList(
            data.resultset_1.map((i) => {
              i.isExpanded = data.resultset_2[0]?.isExpanded;
              return i;
            })
          );
          setColumnsList(JSON.parse(data.resultset_2[0]?.Tabela_Colunas));
          setResultset2(data.resultset_2[0]);
          if (data?.resultset_2[0].Total_Registros && paginator) setTotalRecords(data?.resultset_2[0]?.Total_Registros);
          if (data?.resultset_2[0].ID_Consulta) setIdConsulta(data?.resultset_2[0]?.ID_Consulta);
        }
      })
      .catch((e) => {
        console.log("Erro ao se comunicar com o Backend", e);
        setMessageError("Erro ao se comunicar com o Backend");
      });
  };

  const footerGroup = (
    <ColumnGroup>
      <Row>
        {columnsList.map((col, i) => (
          <Column key={i} footer={col?.footer} />
        ))}
      </Row>
    </ColumnGroup>
  );

  const paginatorLeft = (props) => {
    return (
      <div className="d-flex container-left-paginator align-items-center p-0 m-0 gap-4">
        <div
          style={{ width: 150 }}
          className="font-size-12 text-black bg-light_gray_05 p-3 rounded-start-4 text-center"
        >
          <span className="text-primary fw-bold">Totalizadores</span>
        </div>
        <div className="col">
          <div className="d-flex align-items-center gap-3">
            <div className="font-size-12 text-black">
              Total teste 1:{" "}
              <span className="text-primary fw-bold">R$ 200.000,22</span>
            </div>
            <div className="font-size-12 text-black">
              Total teste 1:{" "}
              <span className="text-primary fw-bold">R$ 200.000,22</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const paginatorTemplate = {
    layout: "RowsPerPageDropdown PrevPageLink PageLinks NextPageLink",
    PageLinks: (options) => {
      if (
        (options.view.startPage === options.page &&
          options.view.startPage !== 0) ||
        (options.view.endPage === options.page &&
          options.page + 1 !== options.totalPages)
      ) {
        const className = classNames(
          options.className,
          { "p-disabled": true },
          "rounded-0 m-0"
        );
        return <span className={className}> ... </span>;
      }

      return (
        <button
          type="button"
          className={options.className}
          onClick={options.onClick}
        >
          {options.page + 1}
          <Ripple />
        </button>
      );
    },
    RowsPerPageDropdown: (options) => {
      const dropdownOptions = [
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 30, value: 30 },
        { label: "All", value: options.totalRecords },
      ];

      return (
        <Row className="p-0 m-0 d-flex align-items-center gap-2">
          <span className="font-size-14 text-black">Resultados por página</span>
          <Dropdown
            className="mx-2"
            value={options.value}
            options={dropdownOptions}
            onChange={options.onChange}
          />
        </Row>
      );
    },
  };

  useEffect(() => {
    if (!productList.length) {
      getDataOnExpandedRow();
    }
  }, []);

  useEffect(() => {
    getDataOnExpandedRow();
  }, [Visao, filterEmpresa])

  return (
    <div>
      {productList.length && !messageError ? (
        <>
          {isLoading && <div className="w-100 pb-3"><Spinner className="text-primary" size="md" /></div>}
          <PrimeDataTable.DataTable
            tableClassName="table mb-0 table-light font-size-14 table-sm "
            value={productList}
            paginatorTemplate={paginatorTemplate}
            sortMode="single"
            groupRowsBy={!groupByKey ? "Codigo_Produto_Revenda" : groupByKey}
            rowGroupMode="rowspan"
            expandedRows={expandedRows}
            onRowToggle={(e) => setExpandedRows(e.data)}
            rowExpansionTemplate={rowExpansionTemplate}
            dataKey={dataKey}
            reorderableColumns
            paginatorClassName="paginator-table-custom mt-3 p-0"
            paginatorLeft={paginatorLeft}
            footerColumnGroup={
              resultset2?.isFooter == "S" ? footerGroup : <></>
            }
            pageLinkSize={6}
            totalRecords={totalRecords}
            paginator={paginator}
            rows={10}
          >
            {columnsList.map((col, i) => (
              <Column
                style={{paddingLeft: (i === 0 ? paddingLeft : 10)}}
                key={col.field}
                sortable
                headerStyle={{
                  color: "white",
                  background: resultset2?.bgColor ? resultset2?.bgColor : "",
                  width: col?.width ? col.width : "auto",
                }}
                bodyStyle={{
                  padding: `0 10px 0 ${paddingLeft}`,
                }}
                field={col.field}
                body={eval(col.body)}
                header={col.header}
              />
            ))}
          </PrimeDataTable.DataTable>
        </>
      ) : (
        <div className="w-100 d-flex align-items-center justify-content-center p-1">
          {messageError ? (
            <Alert className="w-100" color="warning">
              <p className="m-0 p-0">{messageError}</p>
            </Alert>
          ) : (
            <Spinner className="text-primary" />
          )}
        </div>
      )}
    </div>
  );
};

export {
  BasicTable,
  ScrollVertical,
  ScrollHorizontal,
  AlternativePagination,
  FixedHeaderDatatables,
  ModalDataDatatables,
  GroupDatatables,
};
